<template>
  <div class="page" @touchmove.prevent>
    <div class="bg-window"></div>
    <div class="main">
      <!-- <div class="about-me">关于我</div> -->
      <img class="pic-about-me" src="https://static.huiyiji520.com/cppic-1661154078.png">
      <!-- <div class="hint">你的性别？</div> -->
      <img class="pic-hint" src="https://static.huiyiji520.com/cppic-1661157326.png">
      <div class="btn male" @click="chooseSex('male')" :style="{color: getBtnColor('male'), backgroundColor: getBtnBackground('male')}">男</div>
      <div class="btn female" @click="chooseSex('female')" :style="{color: getBtnColor('female'), backgroundColor: getBtnBackground('female')}">女</div>
      <div class="arrows">
        <!-- <div class="next" @click="goNext()">下一步<van-icon name="arrow" color="#eb8e80" /></div> -->
        <img class="pic-next" @click="goNext()" src="https://static.huiyiji520.com/cppic-1661157292.png">
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Icon } from 'vant'

export default{
  components: {
    [Toast.name]: Toast,
    [Icon.name]: Icon
  },
  data(){
    return {
      sex: ''
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    goNext(){
      if(!this.sex){
        Toast('请选择你的性别')
      }else{
        let cpchoose = this.$store.state.cpchoose
        cpchoose.mySex = this.sex
        this.$store.commit('updateCpChoose', cpchoose)
        this.handleRouter('/choose_me_age')
      }
    },
    chooseSex(sex){
      let paid = this.$store.state.userinfo.paid
      if(paid == 1){
        Toast('性别不可修改，请点击下一步')
      }else{
        this.sex = sex
      }
    },
    getBtnColor(sex){
      return this.sex == sex ? '#fff' : '#f1b8af'
    },
    getBtnBackground(sex){
      return this.sex == sex ? '#f1b8af' : '#fff'
    },
    getReferal(){
      let searchParams = new URLSearchParams(window.location.search)
      let referal = searchParams.get("referal") ? searchParams.get("referal") : "matrix"
      // alert('sex referal: ' + referal)
      this.$store.commit('setReferal', { referal: referal })
    },
    getCoupon(){
      let searchParams = new URLSearchParams(window.location.search)
      let coupon = searchParams.get("coupon") ? searchParams.get("coupon") : "matrix"
      this.$store.commit('updateCoupon', { coupon: coupon })
    },
    recoverSex(){
      this.sex = this.$store.state.cpchoose.mySex ? this.$store.state.cpchoose.mySex : this.sex
    }
  },
  mounted(){
    this.getReferal()
    // this.getCoupon()
    this.recoverSex()
    this.$report.submit('/choose_me_sex', this.$store.state.issue, this.$store.state.userinfo.openid)
  }
}
</script>

<style scoped>
.page{min-height:100vh;}
.bg-window{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url("https://static.huiyiji520.com/cppic-1661155471.png");
  background-size:100% 100%;
  background-repeat:no-repeat;
  /* opacity:0.1; */
  z-index:-1;
}
.main{text-align:center;}
.main .about-me{margin-top:200px;margin-bottom:134px;font-size:70px;color:#eb8e80;}
.main .hint{font-size:40px;line-height:40px;color:#eb8e80;margin-bottom:160px;}
.main .pic-about-me{width:206px;height:68px;margin:0 auto;margin-top:208px;margin-bottom:146px;}
.main .pic-hint{width:188px;height:42px;margin:0 auto;margin-bottom:160px;}
.main .btn{
  width:342px;height:110px;line-height:110px;font-size:40px;border:5px solid #f1b8af;border-radius:30px;
  margin:0px auto;color:#f1b8af;background:#fff;
}
.main .btn.female{margin-top:80px;}
.main .arrows{
  position: fixed;bottom:120px;width:100%;font-size:32px;font-weight:bold;
  color:#eb8e80;
}
.main .pic-next{width:121px;height:34px;margin:0 auto;}
</style>
